import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import {
    accountStatusCheckForLinking as accountStatusCheckForLinkingAction,
    clearAuthNotification as clearAuthNotificationAction,
    linkAccountOnNewUser,
    existingAccountCheck,
    setEmail,
} from '../../actions/auth';

import {
    trackSIWA_AccountsLinkOptionWithHiddenEmail,
    trackSIWA_AccountLinkAttemptWithHiddenEmail,
} from '../../actions/gaTracking';

import ExistingAccountScreen from './ExistingAccountScreen';

const _mapStateToProps = ({ authentication }) => ({
    socialAuthenticationData: authentication.socialAuthenticationData,
    authNotificationOptions: authentication.authNotificationOptions,
    shouldRenderAuthNotification: !isEmpty(
        authentication.authNotificationOptions,
    ),
    userHasAccount: authentication.userHasAccount,
});

const _mapDispatchToProps = {
    onAccountStatusCheck: accountStatusCheckForLinkingAction,
    clearAuthNotification: clearAuthNotificationAction,
    linkAccountOnNewUser,
    onExistingAccountCheck: existingAccountCheck,
    setEmail,
    trackOnLoadPage: trackSIWA_AccountsLinkOptionWithHiddenEmail,
    trackOnYesButton: trackSIWA_AccountLinkAttemptWithHiddenEmail,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(ExistingAccountScreen),
);
